module.exports = __webpack_public_path__ + "static/img/hall02.1eb97b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/hall02.jpg
// module id = B0qC
// module chunks = 1